import { render, staticRenderFns } from "./CreateQRCode.vue?vue&type=template&id=5fcb38c8&scoped=true&"
import script from "./CreateQRCode.vue?vue&type=script&lang=js&"
export * from "./CreateQRCode.vue?vue&type=script&lang=js&"
import style0 from "./CreateQRCode.vue?vue&type=style&index=0&id=5fcb38c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcb38c8",
  null
  
)

export default component.exports